import * as React from 'react';
import { Dispatch } from 'redux';
import { AddParticipantRequest } from 'stageclip-common';

import { BaseApiPostRequest } from '../generic/baseApiPostRequest';
import * as EntityNormalizers from '../normalizers/entityNormalizers';
import * as ParticipantNormalizers from '../normalizers/participantNormalizers';

export class AddEventParticipantRequest extends BaseApiPostRequest<
  AddParticipantRequest,
  EntityNormalizers.NormalizedSingleEntity<ParticipantNormalizers.NormalizedParticipants>
> {
  constructor(eventId: string, formData: AddParticipantRequest, component: React.Component, dispatch: Dispatch) {
    super(formData, component, dispatch);
    this.path = `/events/${eventId}/participants`;
    this.normalizeMethod = ParticipantNormalizers.normalizeParticipant;
  }
}
